import { Autocomplete, FormControl, OutlinedInput, Typography } from "@mui/material";
import { useCallback, forwardRef, Dispatch, SetStateAction } from "react";
import { ShareFormValues } from "../modal-create-share";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { DbAssetObjectInfos } from "../../../../Core/Api/Types/db-asset-object-infos";
import { GetMetadataByTagName } from "../../../../Core/Utils/asset-object-utils";
import SearchTitleOrAsset from "../search-title-or-asset";
import { useTranslation } from "react-i18next";

export type ModalCreateShareStepTwoElementProps = {
  formValues: ShareFormValues;
  setFormValues: Dispatch<SetStateAction<ShareFormValues>>;
};

const ModalCreateShareStepTwo = forwardRef<any, ModalCreateShareStepTwoElementProps>((props, ref) => {
  const { t } = useTranslation();
  const { formValues, setFormValues } = props;

  const onObjectTypeSelect = useCallback(
    (value: string | null) => {
      setFormValues((prevState) => ({
        ...prevState,
        isAsset: value !== "A title",
        stepOne: {
          objectInfos: null,
          objectId: null,
          objectName: null,
          objectLayer: null,
          features: [],
          isSeason: false,
          searchResults: [],
        },
        isFormValid: false,
      }));
    },
    [setFormValues]
  );

  const onObjectSelect = (object?: DbAssetObjectInfos) => {
    if (object)
      setFormValues((prevState) => ({
        ...prevState,
        stepOne: {
          objectInfos: object,
          objectId: object.id,
          objectName: object.name,
          objectLayer: object.layer,
          features: [],
          isSeason: GetMetadataByTagName(object, "titleType")?.value !== "Movie",
        },
        isFormValid: true,
      }));
  };

  return (
    <>
      <Typography variant="h5">{t("modal:modalCreateShareStepOne.body.iWantToShare")}</Typography>
      <FormControl>
        <Autocomplete
          id="object"
          defaultValue="A title"
          value={formValues.isAsset ? "An asset" : "A title"}
          options={["A title", "An asset"]}
          onChange={(e, value) => onObjectTypeSelect(value)}
          popupIcon={<ExpandMoreRoundedIcon />}
          getOptionLabel={(value: string) => value || ""}
          sx={{ mb: 3 }}
          renderInput={(params) => (
            <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
          )}
        />
      </FormControl>
      <SearchTitleOrAsset
        isAsset={formValues.isAsset}
        itemSelectedId={formValues.stepOne.objectId ? [formValues.stepOne.objectId] : []}
        onSelect={onObjectSelect}
      />
    </>
  );
});

export default ModalCreateShareStepTwo;
